import React, { useEffect, useMemo, useState } from 'react'
import context from '@/context'
import { ValidationBoundary } from '@/components/validation'
import { ModalBody } from 'reactstrap'
import { BasicHeader } from '@/dialogs/common/basicHeader'
import { FormLoader, FormRow } from '@/components/changeRequests'
import { ChangeItemDialogFooter } from '@/dialogs/common/changeItemDialogFooter'
import LoadingIndicator from '@/components/LoadingIndicator'

function ContactInformationDialog (props) {
  const contactTypeId = useMemo(() => (props.value && props.value.type && props.value.type.id) || undefined, [props.value])
  const [contactTypes, setContactTypes] = useState(null)
  const regex = useMemo(() => {
    if (contactTypes) {
      const type = contactTypes.find(x => x.id === contactTypeId)
      if (type && type.regexValidation) {
        return type.regexValidation
      }
    }
    return undefined
  }, [contactTypes, contactTypeId])
  useEffect(() => {
    setContactTypes(null)
    context.api.codeListService.getCodeList('ContactInformationType')
      .then((data) => {
        setContactTypes(data)
      })
      .catch(() => {
        setContactTypes([])
      })
  }, [])
  if (!contactTypes) return <LoadingIndicator />
  return (
    <FormLoader {...props} render={() =>
      <ValidationBoundary>
        <BasicHeader title='Persons.ContactInformation' {...props} />
        <ModalBody>
          <div className='row'>
            <div className='col-12'>
              <FormRow label='Persons.ContactInformationType' name='type' target={props.target} inputType='lookup' dataSource={context.cache.getContactInformationTypes} clientSide isCodeList required />
              <FormRow label='Persons.ContactInformationValue' name='value' target={props.target} inputProps={{ maxLength: 200 }} regex={regex} required />
              <FormRow label='Persons.PrimaryContactInformation' name='primary' target={props.target} inputType='checkbox' />
            </div>
          </div>
        </ModalBody>
        <ChangeItemDialogFooter {...props} />
      </ValidationBoundary>
    } />
  )
}

export default {
  component: ContactInformationDialog
}



// WEBPACK FOOTER //
// ./src/dialogs/contactInformation.js